import API from '../../../../../../utils/api'
import { NAME } from '../../../../../constants/APIKEYS'
import { CHARTAPI } from '../../../../../constants/TRADEAPIKEYS'

/* eslint-disable @typescript-eslint/no-unused-vars */
export const getLanguageFromURL = () => {
	const regex = new RegExp('[\\?&]lang=([^&#]*)')
	const results = regex.exec(window.location.search)
	return results === null
		? null
		: decodeURIComponent(results[1].replace(/\+/g, ' '))
}

//메인차트
export const widgetOptions = (
	tvWidgetRef,
	paris,
	ep_id,
	updatechart,
	mutateUpdateChart,
	tab,
	lang,
	isDarkMode,
	mobile,
	EPs,
	setEP,
	userid,
	socket
) => {
	const datafeed = new window.Datafeeds.UDFCompatibleDatafeed(CHARTAPI)

	const resolutionIntervalMap = interval => {
		let resolutionsToIntervals = {
			'1m': '1',
			'3m': '3',
			'5m': '5',
			'15m': '15',
			'30m': '30',
			'1h': '60',
			'2h': '120',
			'4h': '240',
			'6h': '360',
			'8h': '480',
			'12h': '720',
			'1d': '1D',
			'1w': '1W',
			'1M': '1M',
		}
		return resolutionsToIntervals[interval]
	}

	lang = lang?.split('-')[0]

	// getBars 오버라이드 - 데이터 요청
		// getBars 오버라이드 - 데이터 요청
		datafeed.getBars = async (
			symbolInfo,
			resolution,
			periodParams,
			onHistoryCallback,
			onErrorCallback
		) => {
			const { from, to, firstDataRequest } = periodParams

			// 최초 로딩 시 300개 봉으로 제한 (성능 개선)
			const countBack = firstDataRequest ? 5000 : 5000

			console.log('[Chart] getBars 호출:', {
				symbol: symbolInfo.ticker,
				resolution,
				from: new Date(from * 1000),
				to: new Date(to * 1000),
				firstDataRequest,
				countBack
			})

			try {
				const url = `${CHARTAPI}/history?symbol=${symbolInfo.ticker}&resolution=${resolution}&from=${from}&to=${to}&countback=${countBack}`
				console.log('[Chart] API 요청:', url)

				const apiStartTime = performance.now()
				const response = await fetch(url)
				const data = await response.json()
				const apiEndTime = performance.now()
				const apiTime = Math.round(apiEndTime - apiStartTime)

				console.log('[Chart] API 응답:', {
					status: data.s,
					bars: data.t?.length || 0,
					apiTime: `${apiTime}ms`
				})

				if (data.s === 'ok' || data.s === 'success') {
					const parseStartTime = performance.now()
					const bars: any[] = []
					const isDailyBar = resolution === '1D' || resolution === 'D'
					const isWeeklyBar = resolution === '1W' || resolution === 'W'
					const isMonthlyBar = resolution === '1M' || resolution === 'M'

					for (let i = 0; i < data.t.length; i++) {
						let barTime: number

						// Daily bars need KST conversion (+9 hours)
						if (isDailyBar) {
							const adjustedTimestamp = (data.t[i] + 9 * 3600) * 1000
							barTime = Math.floor(adjustedTimestamp / 86400000) * 86400000
						} else if (isWeeklyBar) {
							const adjustedTimestamp = (data.t[i] + 9 * 3600) * 1000
							const dayMs = 86400000
							const normalizedDay = Math.floor(adjustedTimestamp / dayMs) * dayMs
							const date = new Date(normalizedDay)
							const dayOfWeek = date.getUTCDay()
							const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1
							barTime = normalizedDay - daysToMonday * dayMs
						} else if (isMonthlyBar) {
							const adjustedTimestamp = (data.t[i] + 9 * 3600) * 1000
							const date = new Date(adjustedTimestamp)
							barTime = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1)
						} else {
							barTime = data.t[i] * 1000
						}

						bars.push({
							time: barTime,
							open: data.o[i],
							high: data.h[i],
							low: data.l[i],
							close: data.c[i],
							volume: data.v[i]
						})
					}
					const parseEndTime = performance.now()
					const parseTime = Math.round(parseEndTime - parseStartTime)

					console.log('[Chart] 데이터 파싱 완료:', {
						bars: bars.length,
						parseTime: `${parseTime}ms`
					})

					// Set lastBar for real-time updates (HTS pattern)
					if (bars.length > 0) {
						if (isDailyBar || isWeeklyBar || isMonthlyBar) {
							// Check if we're requesting current time range
							const checktime = new Date().getTime() / 1000 + 9 * 3600
							console.log('[Chart] DWM bar check:', {
								to,
								checktime,
								isCurrentRange: to >= checktime - 60000,
								resolution
							})

							if (to >= checktime - 60000) {
								const lastbar = bars[bars.length - 1]
								console.log('[Chart] Setting lastBar for DWM:', lastbar)
								socket?.setLastBar(lastbar)
							}
						} else {
							// For intraday bars, clear lastBar (will be set by justSubscribed)
							socket?.setLastBar(null)
						}
					}

					const renderStartTime = performance.now()
					onHistoryCallback(bars, { noData: false })

					// 렌더링 시간은 다음 프레임에서 측정
					requestAnimationFrame(() => {
						const renderEndTime = performance.now()
						const renderTime = Math.round(renderEndTime - renderStartTime)
						console.log('[Chart] 렌더링 완료:', {
							renderTime: `${renderTime}ms`,
							totalTime: `${Math.round(renderEndTime - apiStartTime)}ms`
						})
					})
				} else {
					console.warn('[Chart] 데이터 없음:', data)
					onHistoryCallback([], { noData: true })
				}
			} catch (error) {
				console.error('[Chart] getBars 에러:', error)
				onErrorCallback(error)
			}
		}

	// 심볼 검색 오버라이드 (exchange 추가)
	datafeed.searchSymbols = async (
		userInput,
		exchange,
		symbolType,
		onResultReadyCallback
	) => {
		// 브랜드명을 exchange로 사용 (공백 있으면 앞부분만, 없으면 전체)
		const brandName = NAME ?? ''
		const brandExchange = brandName.includes(' ') ? brandName.split(' ')[0] : brandName

		try {
			const searchResults = await API.get(
				`/search?query=${userInput}&exchange=${brandExchange}&limit=500`,
				null,
				{},
				false,
				CHARTAPI
			)
			// Futures만 필터링
			const futuresOnly = searchResults.filter(
				(item: any) => item.type === 'futures' || item.type === 'Futures' || !item.type
			)
			onResultReadyCallback(futuresOnly)
		} catch (error) {
			console.error('Search symbols error:', error)
			onResultReadyCallback([])
		}
	}

	datafeed.resolveSymbol = async (
		symbolName,
		onSymbolResolvedCallback,
		onResolveErrorCallback,
		extension
	) => {
		// 현재 설정된 종목 정보
		const currentSymbol = EPs?.find(ep => ep?.id == ep_id)?.pairs;

		// 선택된 종목이 현재 종목과 다른 경우
		if (symbolName !== currentSymbol) {
			console.log('다른 종목 선택됨:', symbolName, '현재 종목:', currentSymbol);

			// 선택된 종목에 해당하는 EP 찾기
			const selectedEP = EPs?.find(ep => ep?.pairs === symbolName);

			if (selectedEP) {
				// 페이지 URL 구성 및 이동
				const baseUrl = window.location.pathname.split('/')[1] || '';
				const newUrl = `/${baseUrl}/${selectedEP.id}`;

				console.log('페이지 이동:', newUrl);
				window.location.href = newUrl;
				return;
			}
		}

		// 종목 변경 없이 기존 종목 정보 로드 (항상 서버에서 최신 조회)
		try {
			const symbolInfo = await API.get(
				`/symbols?symbol=${symbolName}`,
				null,
				{},
				false,
				CHARTAPI
			);
			localStorage.setItem(`symbol_${symbolName}`, JSON.stringify(symbolInfo));
			onSymbolResolvedCallback(symbolInfo);
		} catch (error) {
			console.error('Error resolving symbol:', error);
			onResolveErrorCallback();
		}
	}

	

	let currentSubscriptionUID = null;
	let resetCacheCallback: (() => void) | null = null;

	// 외부에서 resetCache를 호출할 수 있도록 전역 함수 노출
	(window as any).__chartResetCache = function() {
		if (resetCacheCallback) {
			console.log('[ChartUtils] __chartResetCache 호출됨')
			resetCacheCallback();
			return true;
		} else {
			console.warn('[ChartUtils] resetCacheCallback이 아직 설정되지 않음')
			return false;
		}
	};

	datafeed.subscribeBars = function (
		symbolInfo,
		resolution,
		onRealtimeCallback,
		subscribeUID,
		onResetCacheNeededCallback
	) {
		console.log('[subscribeBars] 호출:', {
			symbol: symbolInfo.ticker,
			resolution,
			subscribeUID
		})

		if (currentSubscriptionUID && currentSubscriptionUID !== subscribeUID) {
			// 이전 구독 해제
			console.log('[subscribeBars] 이전 구독 해제:', currentSubscriptionUID)
			datafeed.unsubscribeBars(currentSubscriptionUID);
		}

		currentSubscriptionUID = subscribeUID;

		// onResetCacheNeededCallback 저장 (TradingView 공식 캐시 초기화 메커니즘)
		if (onResetCacheNeededCallback) {
			resetCacheCallback = onResetCacheNeededCallback;
			console.log('[subscribeBars] onResetCacheNeededCallback 저장됨')
		}

		const update = {
			datafeed: datafeed,
			resolution: resolution,
			subscribeUID: subscribeUID,
			updatebars: onRealtimeCallback,
			resetCache: resetCacheCallback,
			justSubscribed: true, // getBars 완료 직후 플래그
		}
		console.log('[subscribeBars] updatebars 함수 등록 완료')
		mutateUpdateChart(update)
	}
	return {
		symbol: EPs?.find(ep => ep?.id == ep_id)?.pairs,
		datafeed: datafeed,
		interval: resolutionIntervalMap(tab) || '1',
		container: 'tv_chart_container',
		library_path: '/charting_library/',
		locale: lang || 'en',
		auto_save_delay: 5, // 자동 저장 지연
		load_last_chart: false, // 마지막 차트 로드
		disabled_features: [
			'timeframes_toolbar',
			'volume_force_overlay',
			'show_logo_on_all_charts',
			'save_chart_properties_to_local_storage',
			'caption_buttons_text_if_possible',
			'header_compare',
			'compare_symbol',
			'control_bar',
			'header_widget_dom_node',
			'header_undo_redo',
			'header_interval_dialog_button',
			'border_around_the_chart',
			'show_interval_dialog_on_key_press',
			 'header_symbol_search',
			mobile && 'header_compare',
			'study_templates',
			'use_localstorage_for_settings',
			'header_settings',
			'header_saveload featureset',
			// 'header_resolutions',
			//mobile && 'left_toolbar',
		],
		enabled_features: [
			'countdown',
			mobile && 'hide_left_toolbar_by_default',
			'hide_object_tree_and_price_scale_exchange_label',
			'hide_price_scale_if_all_sources_hidden',
		],
		request_only_visible_range_on_reset: true,
		studies_overrides: {
			'volume.volume.color.0': '#007EDA',
			'volume.volume.color.1': '#F05551',
		},
		overrides: {
			'candleStyle.upColor': '#F05551',
			'candleStyle.downColor': '#007EDA',
			'candleStyle.wickUpColor': '#F05551',
			'candleStyle.wickDownColor': '#007EDA',
			'candleStyle.borderUpColor': '#F05551',
			'candleStyle.borderDownColor': '#007EDA',
			'candleStyle.volumeUpColor': '#F05551',
			'candleStyle.volumeDownColor': '#007EDA',
			'plotLineColor.priceLine.long': '#F05551',
			'plotLineWidth.priceLine.long': 2,
			'plotLineColor.priceLine.short': '#007EDA',
			'plotLineWidth.priceLine.short': 2,
			'mainSeriesProperties.showCountdown': true,
			'scalesProperties.showStudyLastValue': false,
		},
		client_id: (NAME + 'ASSET').toLowerCase(),
		timezone: 'Asia/Seoul',
		charts_storage_url: 'https://saveload.tsaaaccccee.uk',
		charts_storage_api_version: '1.1',
		exchanges: [
			NAME
		],
		user_id: userid,
		fullscreen: false,
		autosize: true,
		theme: isDarkMode ? 'light' : 'dark',
		volume_precision: 0,
	}
}
